(function(){
  'use strict';

  if (window.__esCartRxEditCleanup) {
    try { window.__esCartRxEditCleanup(); } catch (e) {}
  }

  var KEY='es_lb_edit_payload_v1';
  var clickHandler = null;
  var domReadyHandler = null;
  var pageShowHandler = null;
  var booted = false;
  var activeLoadPromise = null;
  var activeRuntimePromise = null;
  var pointerWarmHandler = null;

  function getAssetUrl(name){
    try {
      var map = window.__ES_CART_RX_EDIT_ASSETS || {};
      if (map[name]) return String(map[name]);
      if (name === 'es-lensbuilder.js' && map.lensbuilderJs) return String(map.lensbuilderJs);
      if (name === 'es-lensbuilder.css' && map.lensbuilderCss) return String(map.lensbuilderCss);
    } catch(e) {}
    try {
      var direct = document.querySelector('script[data-es-cart-rx-edit-asset="' + name + '"]');
      if (direct && direct.getAttribute('src')) return String(direct.getAttribute('src'));
    } catch(e2) {}
    return '/assets/' + name;
  }

  function ensureStylesheet(href, marker){
    if (!href) return Promise.resolve();
    try {
      var existing = document.querySelector('link[' + marker + '="1"]') || document.querySelector('link[href*="' + href.split('/').pop().split('?')[0] + '"]');
      if (existing) return Promise.resolve();
    } catch(e) {}
    return new Promise(function(resolve, reject){
      try {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.setAttribute(marker, '1');
        link.onload = function(){ resolve(); };
        link.onerror = function(){ reject(new Error('Failed to load stylesheet: ' + href)); };
        (document.head || document.documentElement).appendChild(link);
      } catch(err) { reject(err); }
    });
  }

  function ensureScript(href, marker){
    if (!href) return Promise.resolve();
    try {
      var existing = document.querySelector('script[' + marker + '="1"]') || document.querySelector('script[src*="' + href.split('/').pop().split('?')[0] + '"]');
      if (existing) {
        if (window.ESLensBuilder && typeof window.ESLensBuilder.init === 'function') return Promise.resolve();
        if (existing.__esReadyPromise) return existing.__esReadyPromise;
      }
    } catch(e) {}
    return new Promise(function(resolve, reject){
      try {
        var script = document.createElement('script');
        script.src = href;
        script.defer = true;
        script.setAttribute(marker, '1');
        script.__esReadyPromise = new Promise(function(res, rej){
          script.onload = function(){ res(); };
          script.onerror = function(){ rej(new Error('Failed to load script: ' + href)); };
        });
        (document.head || document.documentElement).appendChild(script);
        script.__esReadyPromise.then(resolve).catch(reject);
      } catch(err) { reject(err); }
    });
  }

  function ensureLensBuilderRuntime(){
    if (window.ESLensBuilder && typeof window.ESLensBuilder.init === 'function') return Promise.resolve();
    if (activeRuntimePromise) return activeRuntimePromise;
    activeRuntimePromise = Promise.all([
      ensureStylesheet(getAssetUrl('es-lensbuilder.css'), 'data-es-cart-rx-edit-css'),
      ensureScript(getAssetUrl('es-lensbuilder.js'), 'data-es-cart-rx-edit-js')
    ]).then(function(){
      if (window.ESLensBuilder && typeof window.ESLensBuilder.init === 'function') return;
      throw new Error('Lens builder runtime unavailable');
    }).finally(function(){
      activeRuntimePromise = null;
    });
    return activeRuntimePromise;
  }

  function parseBool(v){
    return String(v||'').toLowerCase()==='1' || String(v||'').toLowerCase()==='true';
  }

  function withVariantOnly(href){
    if (!href) return '';
    try {
      var u = new URL(href, window.location.origin);
      var variant = u.searchParams.get('variant') || '';
      var out = new URL(u.pathname, window.location.origin);
      if (variant) out.searchParams.set('variant', variant);
      return out.pathname + out.search;
    } catch(e) {
      return href;
    }
  }

  function setBusy(el, busy){
    if (!el || !el.setAttribute) return;
    try {
      if (busy) {
        el.classList.add('is-loading');
        el.classList.add('is-disabled');
        el.setAttribute('aria-busy', 'true');
        el.setAttribute('aria-disabled', 'true');
      } else {
        el.classList.remove('is-loading');
        el.classList.remove('is-disabled');
        el.removeAttribute('aria-busy');
        el.removeAttribute('aria-disabled');
      }
    } catch(e) {}
  }

  function showLoader(){
    var shown = false;
    try {
      if (typeof window.showPopup === 'function') {
        window.showPopup('.loading');
        shown = true;
      }
    } catch(e) {}
    return function hideLoader(){
      if (!shown) return;
      try { window.hidePopup('.loading'); } catch(e1) {}
      try {
        var loadingEl = document.querySelector('.loading');
        if (loadingEl) loadingEl.classList.remove('loaded-content');
      } catch(e2) {}
    };
  }

  function removeDynamicCartLensBuilders(){
    try {
      var nodes = document.querySelectorAll('[data-es-cart-dynamic-lb="1"]');
      nodes.forEach(function(node){
        try {
          if (node && node.__esLb && typeof node.__esLb.close === 'function' && node.hidden === false) {
            node.__esLb.close();
          }
        } catch(eClose) {}
        try { node.remove(); } catch(eRemove) {
          if (node && node.parentNode) node.parentNode.removeChild(node);
        }
      });
    } catch(e) {}
  }

  function prepareLensBuilderForCartEdit(){
    try {} catch(e3) {}
  }

  function loadLensBuilderDirect(href){
    if (!href) return Promise.reject(new Error('Missing product href'));
    var fetchUrl = withVariantOnly(href);
    if (!fetchUrl) return Promise.reject(new Error('Missing fetch url'));
    if (activeLoadPromise) return activeLoadPromise;

    var hideLoader = showLoader();

    activeLoadPromise = ensureLensBuilderRuntime().then(function(){
      return fetch(fetchUrl, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    })
      .then(function(res){
        if (!res.ok) throw new Error('Lens builder fetch failed');
        return res.text();
      })
      .then(function(html){
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var dataScript = doc.querySelector('script[id^="ESLensBuilderData-"]');
        var root = doc.querySelector('[data-es-lb-root]');
        if (!dataScript || !root) throw new Error('Lens builder markup missing');

        removeDynamicCartLensBuilders();

        var importedScript = document.importNode ? document.importNode(dataScript, true) : dataScript.cloneNode(true);
        var importedRoot = document.importNode ? document.importNode(root, true) : root.cloneNode(true);
        importedScript.setAttribute('data-es-cart-dynamic-lb', '1');
        importedRoot.setAttribute('data-es-cart-dynamic-lb', '1');
        importedRoot.hidden = true;

        document.body.appendChild(importedScript);
        document.body.appendChild(importedRoot);

        if (window.ESLensBuilder && typeof window.ESLensBuilder.init === 'function') {
          window.ESLensBuilder.init();
        } else if (typeof window.__esLensBuilderInit === 'function') {
          window.__esLensBuilderInit();
        }

        if (!importedRoot.__esLb) throw new Error('Lens builder init failed');
        return importedRoot;
      })
      .finally(function(){
        activeLoadPromise = null;
        try { hideLoader(); } catch(e) {}
      });

    return activeLoadPromise;
  }

  function buildPayload(link){
    var ds=link.dataset||{};
    var row = null;
    try { row = link.closest('[data-bundle-id], [data-line-key], [data-cart-line]'); } catch(e) {}
    var rowBundleId = row && row.getAttribute ? (row.getAttribute('data-bundle-id') || '') : '';
    var rowLineKey = row && row.getAttribute ? (row.getAttribute('data-line-key') || '') : '';
    var rowLine = row && row.getAttribute ? parseInt((row.getAttribute('data-cart-line') || row.getAttribute('data-line') || '0'), 10) || 0 : 0;
    var existingKeys = [ds.frameKey || '', ds.lensKey || '', ds.prismKey || ''].filter(Boolean);
    if (!existingKeys.length && rowLineKey) existingKeys.push(rowLineKey);
    return {
      source:'cart',
      path: ds.productPath || '',
      variantId: ds.variantId || '',
      type: ds.rxType || '',
      method: ds.rxMethod || '',
      lensTitle: ds.lensTitle || '',
      lensId: ds.lensId || '',
      lensHandle: ds.lensHandle || '',
      lensVariantId: ds.lensVariantId || '',
      pd: ds.pd || '',
      odRight: ds.odRight || '',
      osLeft: ds.osLeft || '',
      add: ds.add || '',
      readingStrength: ds.readingStrength || '',
      prismOd: ds.prismOd || '',
      prismOs: ds.prismOs || '',
      notes: ds.notes || '',
      hadUpload: parseBool(ds.hadUpload),
      entryStage: ds.entryStage || '',
      frameKey: ds.frameKey || rowLineKey || '',
      lensKey: ds.lensKey || '',
      prismKey: ds.prismKey || '',
      existingKeys: existingKeys,
      bundleId: ds.bundleId || rowBundleId || '',
      bundleQty: Math.max(1, parseInt(ds.bundleQty || '1', 10) || 1),
      line: rowLine,
      ts: Date.now()
    };
  }

  function warmDirectOpen(e){
    var link = e && e.target && e.target.closest ? e.target.closest('[data-es-cart-edit-rx]') : null;
    if (!link) return;
    try { ensureLensBuilderRuntime(); } catch(err) {}
  }

  function handleClick(e){
    var link=e.target && e.target.closest ? e.target.closest('[data-es-cart-edit-rx]') : null;
    if(!link) return;
    e.preventDefault();
    try { e.stopPropagation(); } catch(e0) {}
    try { if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation(); } catch(e1) {}
    if (link.getAttribute('aria-busy') === 'true') return;

    var payload = buildPayload(link);
    try { sessionStorage.setItem(KEY, JSON.stringify(payload)); } catch(err) {}

    var href = link.getAttribute('href') || payload.path || '/';
    setBusy(link, true);

    loadLensBuilderDirect(href)
      .then(function(root){
        var builder = root && root.__esLb ? root.__esLb : null;
        if (!builder) throw new Error('Missing initialized builder');
        builder.launchSourceEl = link;
        try { builder.__esDirectEditPayload = payload; } catch (ePayload) {}
        try { root.setAttribute('data-es-direct-edit-payload', encodeURIComponent(JSON.stringify(payload))); } catch (eAttr) {}
        try {
          if (payload.variantId) builder._forcedVariantId = String(payload.variantId);
        } catch(eForced) {}
        try {
          builder.refreshCurrentVariant({ allowHidden:true, deferFooterLayout:true });
        } catch(eRefresh) {}
        prepareLensBuilderForCartEdit();
        builder.open();
      })
      .catch(function(err){
        try { console.error('[ES Cart Edit RX] Direct lens form open failed; falling back to PDP.', err); } catch(eLog) {}
        try {
          var fallback = href || '/';
          if (fallback.indexOf('openLensBuilder=1') === -1 && fallback.indexOf('openLensBuilder=true') === -1) {
            var u = new URL(fallback, window.location.origin);
            u.searchParams.set('openLensBuilder', '1');
            fallback = u.pathname + u.search + u.hash;
          }
          window.location.href = fallback;
        } catch(eNav) {
          window.location.href = href || '/';
        }
      })
      .finally(function(){
        setBusy(link, false);
      });
  }

  function bind(){
    if (booted) return;
    booted = true;
    if (!clickHandler) clickHandler = handleClick;
    if (!pointerWarmHandler) pointerWarmHandler = warmDirectOpen;
    document.addEventListener('click', clickHandler, true);
    document.addEventListener('pointerenter', pointerWarmHandler, true);
    document.addEventListener('focusin', pointerWarmHandler, true);
  }

  function cleanup(){
    booted = false;
    if (domReadyHandler) document.removeEventListener('DOMContentLoaded', domReadyHandler);
    if (pageShowHandler) window.removeEventListener('pageshow', pageShowHandler);
    if (clickHandler) document.removeEventListener('click', clickHandler, true);
    if (pointerWarmHandler) {
      document.removeEventListener('pointerenter', pointerWarmHandler, true);
      document.removeEventListener('focusin', pointerWarmHandler, true);
    }
  }

  domReadyHandler = bind;
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', domReadyHandler);
  else bind();

  pageShowHandler = function(){
    bind();
  };
  window.addEventListener('pageshow', pageShowHandler);

  window.__esCartRxEditCleanup = cleanup;
})();
